import { BBDTag, Horizontal } from '@gravitate-js/excalibrr'
import type { BBDTagProps } from '@gravitate-js/excalibrr/dist/components/DataDisplay/BBDTag'
import { Button, Tooltip } from 'antd'

type ManyTagProps = {
  tagItems: string[]
  maxCount: number
  showTooltip: boolean
} & Omit<BBDTagProps, 'children'>

export function ManyTag({ tagItems, maxCount, showTooltip = true, ...props }: ManyTagProps) {
  if (!tagItems) return null
  const slicedItems = tagItems.slice(0, maxCount)
  const remainingItems = tagItems.slice(maxCount)

  if (tagItems.length <= maxCount) {
    return (
      <Horizontal style={{ flexWrap: 'wrap' }} className='flex items-center' gap={4}>
        {tagItems.map((item, index) => (
          <BBDTag className='text-ellipsis' key={index} style={{ margin: 0 }} {...props}>
            {item}
          </BBDTag>
        ))}
      </Horizontal>
    )
  }
  return (
    <Horizontal style={{ flexWrap: 'wrap' }} className='flex items-center' gap={4}>
      {slicedItems.map((item, index) => (
        <BBDTag className='text-ellipsis' key={index} {...props} style={{ margin: 0 }}>
          {item}
        </BBDTag>
      ))}
      {showTooltip ? (
        <Tooltip title={remainingItems.join(', ')} destroyTooltipOnHide>
          <BBDTag>+ {remainingItems.length} more</BBDTag>
        </Tooltip>
      ) : (
        <BBDTag>+ {remainingItems.length} more</BBDTag>
      )}
    </Horizontal>
  )
}
